import { FreightType } from 'src/enums/quotation.enum'
import { IUser } from 'src/interfaces/auth/auth.interface'
import { CouponTypeEnum } from 'src/interfaces/coupon/coupon.interface'
import { StoreKit } from 'src/interfaces/kit/kit.interface'
import { OrderKitContent } from 'src/interfaces/order/order.interface'
import { ProductTypes } from '../smart-suggestion/smart-suggestion.model'
export class QuoteMetaStateModel {
  data: IQuoteData
  checkoutData?: Partial<ICheckout>
  proposalData: IProposalData | null
  productsConstraints: IProductConstraint[]
  tabFilters: IFilters
  supplierCompatibilities: { [key: string]: string[] }
  kitComposition: IQuoteItem[]
  chargerKitComposition: StoreChargers[]
  standarKitComposition: StoreKit[]
  controls: IControls
}

export interface IControls {
  currentTab: number
  lastClickedTab: number
}

export interface IFilters {
  panels: any
  inverters: any
  brackets: any
  protections: any
  connectors: any
  cables: any
  accessories: any
}

export interface IProductConstraint {
  id: string
  inverterId: string
  panelId: string
  maximumAmount: number
  minimumAmount: number
  isDeleted: boolean
}

export interface IQuoteData {
  panels: IQuoteItem[]
  inverters: IQuoteItem[]
  brackets: IQuoteItem[]
  protections: IQuoteItem[]
  connectors: IQuoteItem[]
  cables: IQuoteItem[]
  accessories: IQuoteItem[]
}

export interface IQuoteItem {
  id: string
  code: string
  equipment: string
  availability: string
  quantity: number
  value: number
  potency?: number
  origin?: string
  totalPotency?: number
  weight: number
}

export interface ICheckout {
  clients: any[]
  clientsChoices: any[]
  clientsDeliverChoices: any[]
  invoiceTo: any
  deliveryTo: any
  installationValues: IInstallationValues
  commissionValues: IInstallationValues
  rebateValue: number
  availableRebateCredit: number
  discountCoupon: any
  discount: number
  discountType: CouponTypeEnum
  step: CheckoutSteps
  shipping: IShipping
  paymentMethod: IPaymentMethod
  paymentOrigin: string
  paymentType: string
  entry: string
  installments: string
  servicePercentage: string
  externalUser: IUser
  integrator?: ILinkIntegrator
  kitType: KitType
}

export interface IShipping {
  freightType: FreightType
  shippingCost: number
}

export interface IInstallationValues {
  percentage: number
  price: number
}

export enum CheckoutSteps {
  PRE_CHECKOUT = 'PRE_CHECKOUT',
  CHECKOUT = 'CHECKOUT',
}

export interface IPaymentMethod {
  icon: string
  name: string
  value: string
}

export interface IProposalData {
  id: string
  ownerId?: string
  status: string
  paymentStatus: string
  installationStatus: string
  paymentMethod?: string
  orderFeed: IProposalUpdate[]
  uploadedFiles: any[]
  kits?: any[]
  products?: any[]
  meta?: any
  leadId?: string
  person?: string
  poNumber?: string
  totalPrice?: number
  rebate?: number
  author?: any
  totalWeight?: number
  totvsCode?: string
  type: 'PROPOSAL' | 'PURCHASE_ORDER'
  reference?: string
  bydNumber?: string | number
  availableInternalStatus?: any[]
  orderKitContents?: OrderKitContent[]
  invoiceTo?: any
  orderNumber?: string
  invoice?: any
  invoiceToId?: string
  customInvoiceCode?: string
  owner?: any
  deliverTo?: any
  externalUser?: IUser
  externalUserId?: string
  integrator?: ILinkIntegrator
  integratorId?: string
  isEditIntegratorActive: boolean
}

export interface ILinkIntegrator {
  id: string
  document?: string
  displayName?: string
}

export interface IProposalUpdate {
  id: string
  description: string
  content: string
  date: string | Date
  creatorName: string
  status?: string
  type: string
}

export interface IDiscountData {
  discount: number
  discountType: CouponTypeEnum
}

export interface IDeliverToAddress {
  city: string
  complement: string
  country: string
  neighborhood: string
  number: string
  state: string
  street: string
  zipCode: string
  displayName: string
}

export interface SummaryValues {
  shipping?: IShipping
  equipmentPrice?: number
  installationValues?: IInstallationValues
  commissionValues?: IInstallationValues
  rebateValue?: number
  discountCoupon?: any
  discountValue?: number
  proposalTotalPrice?: number
  equipmentsPotency?: number
  costPerWatt?: number
}

export enum OriginTypes {
  NATIONAL = 'NATIONAL',
  IMPORTED = 'IMPORTED',
}

export type StoreChargers = IQuoteItem & {
  price: number
  amount: string
  type: ProductTypes
}

export const wifiPlugIds = ['6438547f2781445f747dc6e1']

export type TabFilters = { tab: string; filters: any }

export enum KitType {
  STANDARD = 'STANDARD',
  FINAME = 'FINAME',
  CUSTOM = 'CUSTOM',
  CHARGER = 'CHARGER',
}
